import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class TherapistEventModel extends BaseModel {

    constructor(source?: TherapistEventModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._therapistEventID = 0;
            this._therapistID = 0;
            this._eventID = 0;
        }
    }

// private properties
    _therapistEventID: number = 0;
    _therapistID: number = 0;
    _eventID: number = 0;
    _startDate: Date = new Date();
    _active: boolean = false;

// public properties
    public get therapistEventID(): number
    {
        return this._therapistEventID;
    }
    public set therapistEventID(v: number)
    {
        if (v !== this._therapistEventID)
        {
            this._therapistEventID = v;
            this.propertyChanged.emit(new propertyChangedArguments("therapistEventID", this));
        }
    }

    public get therapistID(): number
    {
        return this._therapistID;
    }
    public set therapistID(v: number)
    {
        if (v !== this._therapistID)
        {
            this._therapistID = v;
            this.propertyChanged.emit(new propertyChangedArguments("therapistID", this));
        }
    }

    public get eventID(): number
    {
        return this._eventID;
    }
    public set eventID(v: number)
    {
        if (v !== this._eventID)
        {
            this._eventID = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventID", this));
        }
    }

    public get startDate(): Date
    {
        return this._startDate;
    }
    public set startDate(v: Date)
    {
        if (v !== this._startDate)
        {
            this._startDate = v;
            this.propertyChanged.emit(new propertyChangedArguments("startDate", this));
        }
    }

    public get active(): boolean
    {
        return this._active;
    }
    public set active(v: boolean)
    {
        if (v !== this._active)
        {
            this._active = v;
            this.propertyChanged.emit(new propertyChangedArguments("active", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: TherapistEventModel): void {
        if (source == null) return;
        this._therapistEventID = source.therapistEventID;
        this._therapistID = source.therapistID;
        this._eventID = source.eventID;
        this._startDate = source.startDate;
        this._active = source.active;
    }


}
